import { render } from "./ProductList.vue?vue&type=template&id=1b833d57"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
script.render = render

export default script